window.addEventListener('DOMContentLoaded', function() {
  // adjust font size of long product titles
  let padding = ($(window).width() > 799) ? 70 : 0;
  let containerWidth = $(".js-product-single-meta").width() +  padding;
  const $text = $(".js-product-single__title");
  let fontSize = ($(window).width() > 799) ? 53 : 41;
  if($text.width() > containerWidth) {
    while ($text.width() > containerWidth) {
      $text.css("font-size", fontSize -= 0.5);
    }
  }

  if($('.js-radio-option-selector').length) {
    $('.js-radio-option-selector :radio').change(function() {
      let optionIndex = $(this).closest('.product-form__options-wrapper').attr('data-index');
      let optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector-'+optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  }

  // product media boxes - product details / supplement facts / whats inside
  $('[data-product-single-media-box]').on('click keypress', function(event){
    if(a11yClick(event) === true){
      $(this).addClass('active');
      if($(this).hasClass('init')) {
        //$('.js-product-single-meta').addClass('product-init');
        //$('.js-meta-box').show();
      }
      else {
        //$('.js-product-single-meta').removeClass('product-init');
        //$('.js-meta-box').hide();
      }

      $('[data-product-single-media-box]').not(this).removeClass('active');
      let mediaId = $(this).attr('data-media-box-id');
      $('[data-product-single-media-wrapper]').addClass('hide');
      $('[data-media-id="'+ mediaId +'"]').removeClass('hide');
    }
  });


  // Product Information popup
  $(".js-show-popup").on('click', function(event){
    let target = $(this).data('target');
    if($(target).length) {
      $(target).fadeToggle();
      $(target).css({"visibility":"visible","display":"block"});
      $('body').addClass('no-scroll');
    }
  });
  $(".js-close-popup").on('click', function(event){
    let target = $(this).closest('.js-popup-wrapper');
    if($(target).length) {
      $(target).fadeToggle();
      $(target).css({"visibility":"visible","display":"block"});
      $('body').removeClass('no-scroll');
    }
  });

  // Frequenlty Bought
  if($('.js-product-upsell-slider').length) {
    $('.js-product-upsell-slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 3,
      infinite: false,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: true
          }
        },
        {
          breakpoint: 374,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

   // Daily Packs
  if($('.js-product-pack-slider').length) {
    $('.js-product-pack-slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 3,
      infinite: false,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 425,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }


  // sup image
  $(".sfbox").click(function(){
    $(".supplement-facts").not('.selected').addClass("hide");
    $(".supplement-facts.selected").removeClass("hide");
  });
});
